// 初期データの生成関数
function getDefaultState() {
  return {
    userAccount: null,
  };
}

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    RESET_STATE(state) {
      // state = detDefaultState()だと"Assignment to function parameter 'state'が発生する"
      Object.assign(state, getDefaultState());
    },
    USER_ACCOUNT(state, item) {
      state.userAccount = item;
    },
  },

  getters: {
    userAccount(state) {
      return state.userAccount;
    },
  },

  actions: {
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    async updateProfile({ commit }, userAccount) {
      try {
        commit("USER_ACCOUNT", userAccount);
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
  },
};
